// Percorso file: src/components/HomeShell.jsx
//
// Telaio comune di tutte le pagine ricostruite: intestazione (doc 07
// §7.1 barra utente + §7.2 banda di navigazione) e colonna centrale
// (§4). Esiste per una ragione sola: che l'intestazione sia LA STESSA
// ovunque, senza copiarla in ogni pagina.
//
// Props:
//   backTo     — rotta della metà «Back»; se assente la metà si omette
//                (home di primo livello, doc 07 §7.2). Può anche essere
//                una FUNZIONE, che il Back chiama al posto di navigare:
//                serve alla scheda del tesserato, il cui «indietro» è
//                «da dove si è venuti» e non una rotta fissa (vedi
//                NavBand.jsx).
//   showSwitch — false solo dove «Switch role» non ha senso (la finestra
//                di scelta ruolo è già lo switch)
//   showLogout — true SOLO sulle schermate-vicolo cieco (default false,
//                cantiere LOGOUT-1): il Logout vive in More / Assistance, e
//                nella barra resta solo dove More non si raggiunge. Passa a
//                UserBar, che spiega il perché e la regola: ogni
//                schermata-vicolo cieco deve accenderla.
//   width      — larghezza della colonna centrale:
//                "column" (predefinita) = colonna standard §4 (90%,
//                massimo 460px, centrata);
//                "admin" = colonna degli strumenti admin §8.1: sopra i
//                768px NON ha larghezza massima — occupa tutta la
//                finestra (100%) con 24px di margine interno per lato
//                (rev. utente 6/8/2026). Sotto i 768px le due larghezze
//                coincidono. Il valore predefinito NON cambia di un
//                pixel per le pagine che già usano il telaio.

import React from "react";
import UserBar from "./UserBar";
import NavBand from "./NavBand";
import "./HomeShell.css";

const HomeShell = ({
  backTo = null,
  showSwitch = true,
  showLogout = false,
  width = "column",
  children
}) => (
  <div className="qpsc-page">
    <UserBar showLogout={showLogout} />
    <NavBand backTo={backTo} showSwitch={showSwitch} />
    <main
      className={
        width === "admin" ? "qpsc-column qpsc-column--admin" : "qpsc-column"
      }
    >
      {children}
    </main>
  </div>
);

export default HomeShell;
